export default __webpack_public_path__ + "static/media/teacher-black.225d3476.svg";